export const PAYMENT_METHOD_LABELS = {
  cash: '💵 เงินสด',
  transfer: '📱 โอน',
  card: '💳 บัตร',
  qr: '📲 QR',
  government: '🏛️ โครงการรัฐ',
  mixed: '🔀 แบ่งจ่าย'
};

export function getPaymentMethodLabel(method) {
  return PAYMENT_METHOD_LABELS[method] || PAYMENT_METHOD_LABELS.cash;
}
